"use client";

import type { Control, FieldValues, Path } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@garagem/ui/components/form";
import { Checkbox } from "@garagem/ui/components/checkbox";

const CONSENT_FIELDS = [
  {
    name: "acceptTerms",
    label: "Li e aceito os Termos de Uso",
    href: "https://garagem.ai/termos",
  },
  {
    name: "acceptPrivacy",
    label: "Li e aceito a Política de Privacidade",
    href: "https://garagem.ai/privacidade",
  },
  {
    name: "acceptAiTransparency",
    label: "Li e aceito a Transparência de IA",
    href: "https://garagem.ai/transparencia-ia",
  },
] as const;

export function SignUpLegalConsentFields<T extends FieldValues>({
  control,
  disabled,
}: {
  control: Control<T>;
  disabled: boolean;
}) {
  return (
    <div className="space-y-3">
      {CONSENT_FIELDS.map((item) => (
        <FormField
          key={item.name}
          control={control}
          name={item.name as Path<T>}
          render={({ field }) => (
            <FormItem className="flex flex-row items-start gap-2 space-y-0">
              <FormControl>
                <Checkbox
                  checked={field.value === true}
                  onCheckedChange={(checked) => field.onChange(checked === true)}
                  disabled={disabled}
                  aria-label={item.label}
                />
              </FormControl>
              <div className="space-y-1 leading-none">
                <FormLabel className="font-normal">
                  <a
                    href={item.href}
                    target="_blank"
                    rel="noreferrer"
                    className="underline"
                    onClick={(event) => event.stopPropagation()}
                  >
                    {item.label}
                  </a>
                </FormLabel>
                <FormMessage />
              </div>
            </FormItem>
          )}
        />
      ))}
    </div>
  );
}
